import { render, staticRenderFns } from "./RegisteredUserReport.vue?vue&type=template&id=7c0bf0e4"
import script from "./RegisteredUserReport.vue?vue&type=script&lang=js"
export * from "./RegisteredUserReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports